import freeEmailDomains from 'free-email-domains'
import Joi from 'joi'

/**
 * Joi Custom Validation to check if an email is in a blocked domain list
 *
 */
export const notBlockedDomain = (value: string): string => {
  const domain: string = value.substring(value.indexOf('@') + 1).toLowerCase()
  // Based on HubSpot blocked domains https://knowledge.hubspot.com/forms/what-domains-are-blocked-when-using-the-forms-email-domains-to-block-feature
  const isOnBlockedDomains = freeEmailDomains.includes(domain)
  if (isOnBlockedDomains) {
    throw new Error('email.blocked.domain')
  }
  return value
}

export const contentSelected = (value): unknown => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  const booleansValid = Object.keys(value)
    .filter((clave) => /^contentSelected-[\w-]+$/.test(clave))
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    .filter((clave) => value[clave] === true)
  if (booleansValid.length === 0) {
    throw new Error('minimum.one.option')
  }
  return value
}

export const keysStep1 = {
  step: Joi.number().required(),
  form: Joi.string().required(),
  downloads: Joi.optional(),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .custom(notBlockedDomain, 'not blocked email')
    .required(),
  terms: Joi.boolean(),
  privacy: Joi.boolean(),
  token: Joi.string(),
  newcontact: Joi.boolean().required(),
  campaign: Joi.optional(),
  matomoUID: Joi.optional(),
  utmSource: Joi.optional(),
  utmMedium: Joi.optional(),
  utmContent: Joi.optional(),
  mtmPlacement: Joi.optional()
}
export const keysStep2 = {
  name: Joi.string().required(),
  role: Joi.string().required(),
  company: Joi.string().required(),
  industry: Joi.string().required(),
  country: Joi.string().required(),
  terms: Joi.boolean().invalid(false).required(),
  privacy: Joi.boolean().invalid(false).required(),
  token: Joi.string().required()
}
export const schemaStepEmail = Joi.object().keys(keysStep1)

export const schemaStepContactInfo = Joi.object().keys({
  ...keysStep1,
  ...keysStep2
})

export const schemaStepSelectContents = Joi.object()
  .keys({
    ...keysStep1,
    ...keysStep2
  })
  .pattern(/^contentSelected-[\w-]+$/, Joi.boolean())
  .custom(contentSelected)

export const schemaStepSelectContentsContactExist = Joi.object()
  .keys({
    ...keysStep1
  })
  .pattern(/^contentSelected-[\w-]+$/, Joi.boolean())
  .custom(contentSelected)
